module.exports = __webpack_public_path__ + "static/media/hhOp.8067a995.wav";